import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=12988d56&scoped=true&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=12988d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12988d56",
  null
  
)

export default component.exports